const format = (v) => (String(v).length === 1 ? `0${v}` : v)

const insert = (el, { h, m, s }) => {
  const hours = el.querySelector(".hours")
  if (hours) hours.textContent = h
  const minutes = el.querySelector(".minutes")
  if (minutes) minutes.textContent = m
  const seconds = el.querySelector(".seconds")
  if (seconds) seconds.textContent = s
}

class Countdown {
  constructor(el, updateTs, tc) {
    this.el = el
    this.updateTs = updateTs
    this.tc = tc
    this.timer = null
  }

  start() {
    this.update()
    this.timer = setTimeout(() => {
      this.start()
    }, 1000)

    return this
  }

  stop() {
    clearTimeout(this.timer)

    return this
  }

  update() {
    const delta = this.updateTs - Math.round(Date.now() / 1000 + this.tc)
    const h = format(Math.abs(Math.floor(delta / 3600)))
    const m = format(Math.abs(Math.floor((delta % 3600) / 60)))
    const s = format(Math.abs(delta % 60))
    insert(this.el, { h, m, s })

    return this
  }
}

export default function setListeners() {
  const { FCGON } = window
  if (!FCGON) return []

  const { forecastUpdateTime, serverTime } = FCGON
  if (!forecastUpdateTime || !serverTime) return []

  const timeCorrection = serverTime - Date.now() / 1000
  const els = document.querySelectorAll("[data-countdown]")

  return [...els].map((el) => new Countdown(el, forecastUpdateTime, timeCorrection).start())
}
